/*eslint-disable */
import React, { useEffect, useState } from "react";
import MenuLayouts from "../layouts/menu.layout";
import FooterLayouts from "../layouts/footer.layout";
import BtnFloatingLayout from "../layouts/btn_flotante.layout";
import {
  lastNewsforCategories,
  NewsOneForDate,
} from "../components/conexion/blogs.conexion";
import { useParams } from "react-router-dom";
import OtrosVehiculosDinamicoComponent from "../components/vehiculos-detail/otros-vehiculos-dinamico.component";
import BannerComponent from "../components/quienes-somos/banner.component";
import ProgresoComponent from "../components/quienes-somos/progreso.component";
import PropositoComponent from "../components/quienes-somos/proposito.component";
import ValoresComponent from "../components/quienes-somos/valores.component";
import CompromisoComponent from "../components/quienes-somos/compromiso.component";
import RellenoComponent from "../components/quienes-somos/relleno.component";
import ArticulosComponent from "../components/quienes-somos/articulos.component";

const QuienesSomosPage: React.FC = () => {
  const { category } = useParams<{ category?: string }>();
  const [visibleHeight, setVisibleHeight] = useState(0);
  const [lastNewsData, setLastNewsData]: any = useState([]);
  const [newsForCategories, setNewsForCategories]: any = useState([]);
  const [opportunities, setOpportunities]: any = useState([]);

  useEffect(() => {
    lastNewsforCategories().then(function (res: any) {
      let posts: any = [];
      res?.data?.data[0].Categories.forEach((element: any) => {
        element.posts.forEach((pos: any) => {
          pos.category_id = element.category_id;
          pos.category = element.category;
          posts.push(pos);
        });
      });

      // Ordenar los posts por fecha de creación de forma descendente
      const sortedPosts = posts.sort(
        (a: any, b: any) =>
          new Date(b.creation_datetime).getTime() -
          new Date(a.creation_datetime).getTime()
      );

      // Obtener los 4 más recientes
      setNewsForCategories(sortedPosts.slice(0, 4));
      setOpportunities(res?.data?.data[0].Opportunities);
    });
  }, []);

  return (
    <>
      <MenuLayouts
        className="home-page"
        active="somos"
        setVisibleHeight={setVisibleHeight}
        visibleHeight={visibleHeight}
      />
      <div
        className="home-page" /* style={{backgroundColor: "#F6F3F2", height: "100vh"}} */
      >
        <h1
          style={{ position: "absolute", opacity: "0", pointerEvents: "none" }}
        >
          Conoce Hyundai Colombia - Nuestra Historia y Compromiso
        </h1>

        <div className="home-page-mascara"></div>
        <BannerComponent />
        <ProgresoComponent />
        <PropositoComponent />
        <ValoresComponent />
        <CompromisoComponent />
        <RellenoComponent />
        <ArticulosComponent newsForCategories={newsForCategories} />
        <OtrosVehiculosDinamicoComponent opportunities={opportunities} />
      </div>
      <BtnFloatingLayout reserva="https://reservas.hyundaicolombia.co/" />
      <FooterLayouts />
    </>
  );
};

export default QuienesSomosPage;
